import React from 'react';
import { Widgets } from 'Utils/Widgets/Widgets';
import { WidgetCard } from '../Components/WidgetCard';
import {
  temperatureWidgetData,
  rainWidgetData,
  windWidgetData,
  humidityAMKWidgetData,
  atmospherePressureAMKWidgetData,
  batteryVoltageAMKWidgetData,
  radiationLevelAMKWidgetData,
  snowDepthAMKWidgetData,
  soilTemperatureLevelAMKWidgetData,
  visibilityAMKWidgetData,
  complexAMKChart1,
  complexAMKChart2,
  complexAMKChart3,
  complexAMKChart4,
  windRoseChartWidgetData,
  windRoseWidgetArrowAMKWidgetData,
} from './amkWidgetsData';
import MapWidgetWrapper from '../Components/MapWidgetWrapper';
import { WindRoseChartWrapper } from '../Components/WindRoseChartWrapper';
import { WidgetChart } from '../Components/WidgetChart';

export default function AmkMonitor() {
  return (
    <div style={{
      margin: '.5rem',
      maxWidth: '1000px',
      width: '1000px',
      display: 'grid',
      gridTemplateRows: 'repeat(2,max-content) 1fr',
      gap: '1rem',
      justifySelf: 'center',
    }}
    >
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gridGap: '.5rem', gridTemplateRows: 'max-content' }}>
        <WidgetCard
          widgetData={temperatureWidgetData}
          widgetLayout={Widgets.Temperature}
        />
        <WidgetCard
          widgetData={windWidgetData}
          widgetLayout={Widgets.Wind}
        />
        <WidgetCard
          widgetData={rainWidgetData}
          widgetLayout={Widgets.Rain}
        />
        <WidgetCard
          widgetData={humidityAMKWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={atmospherePressureAMKWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gridGap: '.5rem', gridTemplateRows: 'max-content' }}>
        <WidgetCard
          widgetData={soilTemperatureLevelAMKWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={snowDepthAMKWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={radiationLevelAMKWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={visibilityAMKWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={batteryVoltageAMKWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', columnGap: '.5rem' }}>
        <WindRoseChartWrapper
          windRoseChartWidgetData={windRoseChartWidgetData}
          windRoseWidgetArrowWidgetData={windRoseWidgetArrowAMKWidgetData}
        />
        <MapWidgetWrapper />
      </div>
      <div style={{
        display: 'grid',
        gridAutoFlow: 'row',
        gridAutoRows: '1fr',
        width: '100%',
      }}
      >
        <WidgetChart
          chartDatasetInfo={complexAMKChart1}
        />
        <WidgetChart
          chartDatasetInfo={complexAMKChart2}
        />
        <WidgetChart
          chartDatasetInfo={complexAMKChart3}
        />
        <WidgetChart
          chartDatasetInfo={complexAMKChart4}
          isModLinear
        />
      </div>
    </div>
  );
}
